import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Hero from './components/Hero';
import ServicesDetail from './components/ServicesDetail';

export default function StrategicBusinessAdvisory() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <ServicesDetail />
      <Footer />
    </div>
  );
}
